export default __webpack_public_path__ + "static/media/nomic.78b3c17e.svg";